module.exports = __webpack_public_path__ + "img/asesoramos-home-back-exotics.7e08f947.png";